import React from 'react';

const LineUndoSvg = ({ size = 18 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M6.75 10.5L3 6.75L6.75 3" />
    <path d="M3 6.75H10.875C11.969 6.75 13.0182 7.1846 13.7918 7.95818C14.5654 8.73177 15 9.78098 15 10.875C15 11.969 14.5654 13.0182 13.7918 13.7918C13.0182 14.5654 11.969 15 10.875 15H8.25" />
  </svg>
);

export default LineUndoSvg;
